var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGestureTwoFingerDrag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.0083 7h-5.0083v-6h10v.50073l.0069-.00073a1.97423 1.97423 0 0 1 .9931.27484v-1.77484h-12v8h6.0083z",
    opacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.0083 3.5a.9986.9986 0 1 1 1.99719 0v4.98566l.01288-.01819a1.05074 1.05074 0 0 1 .90643-.47376 1.06325 1.06325 0 0 1 1.08429 1.03229v.01691a1.0512 1.0512 0 0 1 .90662-.47394 1.06347 1.06347 0 0 1 1.08429 1.03223v.03387l-.00922 3.08623a3.17207 3.17207 0 0 1 -1.01814 2.3115 3.48333 3.48333 0 0 1 -2.43293.9672h-2.62846a3.94133 3.94133 0 0 1 -3.01325-1.3606l-2.63451-3.03283a.95139.95139 0 0 1 -.24109-.78687.998.998 0 0 1 .44769-.6886 1.08414 1.08414 0 0 1 1.34308.11481l1.06751 1a.12088.12088 0 0 0 .12762.03546v-6.28137a.99233.99233 0 0 1 1.98248-.07294v3.57294a.5.5 0 0 0 1 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGestureTwoFingerDrag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gesture-two-finger-drag.2ed2f853f760d49aca15c10d924f5db5.svg";